import { createRoot } from "react-dom/client";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import NextApp from "./NextApp";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<NextApp />);
